/**
 * The message from an RTK Query error body, e.g. a 404's
 * { "message": "Personalized daily prediction not found for date 2026-10-06" }.
 * NestJS validation errors send `message` as an array; those are joined.
 */
export function getApiErrorMessage(error: unknown): string | undefined {
  const body = isRecord(error) ? error.data : undefined;
  if (!isRecord(body)) return undefined;
  const { message } = body;
  const text = Array.isArray(message)
    ? message.filter((m): m is string => typeof m === 'string').join(' ')
    : typeof message === 'string'
      ? message
      : '';
  return text.trim() || undefined;
}

function isRecord(value: unknown): value is Record<string, unknown> {
  return typeof value === 'object' && value !== null && !Array.isArray(value);
}
